import React from 'react';

export const AppleIcon: React.FC = () => (
  <svg className="btn-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M17.63 12.92c-.03-2.18 1.79-3.23 1.87-3.29-1.02-1.49-2.61-1.69-3.16-1.71-1.34-.14-2.63.79-3.31.79-.68 0-1.74-.77-2.86-.75-1.47.02-2.86.86-3.63 2.2-1.55 2.68-.4 6.63 1.11 8.8.75 1.08 1.64 2.29 2.81 2.24 1.12-.04 1.54-.73 2.9-.73 1.36 0 1.73.73 2.92.71 1.21-.02 1.97-1.08 2.71-2.17.87-1.27 1.24-2.51 1.26-2.57-.03-.01-2.42-.93-2.45-3.52z"
      fill="currentColor"
    />
    <path
      d="M15.45 5.74c.59-.72.99-1.7.88-2.69-.85.03-1.88.57-2.49 1.28-.54.64-1.01 1.66-.89 2.64.94.07 1.91-.48 2.5-1.23z"
      fill="currentColor"
    />
  </svg>
);

export const PlayIcon: React.FC = () => (
  <svg className="btn-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      d="M3 5.25v13.5c0 .45.2.85.52 1.12L13.5 12 3.52 4.13A1.47 1.47 0 003 5.25z"
      fill="currentColor"
    />
    <path
      d="M16.04 9.66l-1.79 1.06L7.78 4.35l7.44 4.44c.35.21.74.62.82.87z"
      fill="currentColor"
    />
    <path
      d="M16.04 14.34c-.08.24-.47.66-.82.87L7.78 19.7l6.47-6.38 1.79 1.02z"
      fill="currentColor"
    />
    <path
      d="M20.48 11.19l-2.7-1.62-1.74 1.05L13.5 12l2.54 1.38 1.74 1.05 2.7-1.62c.69-.41.69-1.4 0-1.62z"
      fill="currentColor"
    />
  </svg>
);
